/**
 * Default color palette for datasets in the spider chart.
 */
export const DATASET_COLORS = [
  "#4a90e2", // Default Accent
  "#22c55e", // Green
  "#f59e0b", // Amber
  "#6366f1", // Indigo
  "#ec4899", // Pink
  "#06b6d4", // Cyan
];
